<div class="font-serif">

  <!-- ═══ 1. BANNER SLIDER ═══ -->
  <section *ngIf="slides.length > 0" class="relative w-full overflow-hidden bg-white">
    <div *ngFor="let slide of slides; let i = index; trackBy: trackByIdx"
      [class]="'transition-opacity duration-700 ' + (i === currentSlide ? 'opacity-100 relative' : 'opacity-0 absolute inset-0 pointer-events-none')"
      (click)="onBannerClick(slide)">
      <!-- Desktop image -->
      <img *ngIf="slide.image" [src]="slide.image" [alt]="slide.alt_text || slide.title || 'Banner'"
        class="w-full h-auto hidden md:block cursor-pointer" />
      <!-- Mobile image -->
      <img *ngIf="slide.mobile_image || slide.image" [src]="slide.mobile_image || slide.image" [alt]="slide.alt_text || slide.title || 'Banner'"
        class="w-full h-auto md:hidden cursor-pointer" />
      <!-- Overlay text -->
      <div *ngIf="slide.title || slide.subtitle || slide.button_title"
        class="absolute inset-0 flex items-center"
        [class.justify-start]="slide.position_hor === 'left'"
        [class.justify-center]="slide.position_hor === 'center' || !slide.position_hor"
        [class.justify-end]="slide.position_hor === 'right'">
        <div class="text-white px-8 md:px-16 max-w-xl"
          [class.text-left]="slide.position_hor === 'left'"
          [class.text-center]="slide.position_hor === 'center'"
          [class.text-right]="slide.position_hor === 'right'">
          <h2 *ngIf="slide.title" class="text-2xl md:text-4xl font-bold mb-2 drop-shadow-lg">{{ slide.title }}</h2>
          <p *ngIf="slide.subtitle" class="text-sm md:text-lg mb-4 drop-shadow-md">{{ slide.subtitle }}</p>
          <button *ngIf="slide.button_title"
            class="bg-[#600b0b] text-white px-6 py-2.5 rounded text-sm font-bold uppercase tracking-wider hover:bg-[#8c1c1c] transition-colors">
            {{ slide.button_title }}
          </button>
        </div>
      </div>
    </div>
    <!-- Nav arrows (commented out for now)
    <button *ngIf="slides.length > 1" (click)="prevSlide()" class="absolute left-4 top-1/2 -translate-y-1/2 z-20 bg-white/80 hover:bg-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg transition-all">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
    </button>
    <button *ngIf="slides.length > 1" (click)="nextSlide()" class="absolute right-4 top-1/2 -translate-y-1/2 z-20 bg-white/80 hover:bg-white rounded-full w-10 h-10 flex items-center justify-center shadow-lg transition-all">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
    </button>
    -->
    <!-- Dots -->
    <div *ngIf="slides.length > 1" class="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 flex gap-2">
      <button *ngFor="let s of slides; let i = index"
        (click)="goToSlide(i)"
        [class]="'w-2.5 h-2.5 rounded-full transition-all ' + (i === currentSlide ? 'bg-white scale-125' : 'bg-white/50 hover:bg-white/80')">
      </button>
    </div>
  </section>

  <!-- Banner loading skeleton -->
  <div *ngIf="slides.length === 0" class="w-full bg-gray-200 animate-pulse" style="height: 550px;"></div>

  <!-- ═══ 2. WIDGET BANNER ═══ -->
  <section *ngIf="widget" class="bg-white">
    <div *ngIf="widget.type === 1" class="w-full">
      <img [src]="widget.image" [alt]="widget.alt_text || ''" class="w-full hidden md:block" />
      <img [src]="widget.mobile_image || widget.image" [alt]="widget.alt_text || ''" class="w-full md:hidden" />
    </div>
    <div *ngIf="widget.type === 0" class="max-w-[1440px] mx-auto px-4 py-6 text-center">
      <h3 *ngIf="widget.title" class="text-xl md:text-2xl font-bold text-gray-900 mb-2">{{ widget.title }}</h3>
      <p *ngIf="widget.subtitle" class="text-sm text-gray-600 mb-4">{{ widget.subtitle }}</p>
      <a *ngIf="widget.button_title" [href]="widget.button_link || '#'"
        class="inline-block bg-[#600b0b] text-white px-6 py-2.5 rounded text-sm font-bold uppercase tracking-wider hover:bg-[#8c1c1c] transition-colors">
        {{ widget.button_title }}
      </a>
    </div>
  </section>

  <!-- ═══ 3. ALL CATEGORIES (Hardcoded) ═══ -->
  <section class="bg-white py-8 md:py-12">
    <div class="max-w-[1440px] mx-auto px-4 md:px-6">
      <h2 class="text-2xl md:text-3xl font-serif font-medium text-gray-900 text-center mb-1">All Categories</h2>
      <div class="w-10 h-[1.5px] bg-[#600b0b]/30 mx-auto mt-2 mb-8"></div>
      <div class="grid grid-cols-3 gap-4 md:gap-8 max-w-4xl mx-auto">
        <!-- Wall Art -->
        <a routerLink="/wall-art" class="group text-center cursor-pointer">
          <div class="aspect-square rounded-xl overflow-hidden shadow-md group-hover:shadow-xl transition-all border border-gray-100">
            <img src="assets/images/wall-art/product/1kjhjlk.jpg" alt="Wall Art"
              class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              onerror="this.src='https://content.mahattaart.com/icons/icon3.png'" />
          </div>
          <p class="mt-3 text-sm md:text-base font-semibold text-gray-800 group-hover:text-[#600b0b] transition-colors">Wall Art</p>
        </a>
        <!-- Print & Frame -->
        <a routerLink="/print-frame/photo-frame" class="group text-center cursor-pointer">
          <div class="aspect-square rounded-xl overflow-hidden shadow-md group-hover:shadow-xl transition-all border border-gray-100">
            <img src="assets/images/wall-art/product/Image.jfif" alt="Print & Frame"
              class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              onerror="this.src='https://content.mahattaart.com/icons/icon4.png'" />
          </div>
          <p class="mt-3 text-sm md:text-base font-semibold text-gray-800 group-hover:text-[#600b0b] transition-colors">Print & Frame</p>
        </a>
        <!-- Wallpaper -->
        <a routerLink="/wallpaper-home" class="group text-center cursor-pointer">
          <div class="aspect-square rounded-xl overflow-hidden shadow-md group-hover:shadow-xl transition-all border border-gray-100">
            <img src="assets/images/wall-art/product/wallpaper.jpg" alt="Wallpaper"
              class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              onerror="this.src='https://content.mahattaart.com/icons/icon6.png'" />
          </div>
          <p class="mt-3 text-sm md:text-base font-semibold text-gray-800 group-hover:text-[#600b0b] transition-colors">Wallpaper</p>
        </a>
      </div>
    </div>
  </section>

  <!-- ═══ 4. LATEST WALL ART ═══ -->
  <section *ngIf="wallarts?.length > 0" class="bg-white py-8 md:py-10 border-t border-gray-100">
    <div class="max-w-[1440px] mx-auto px-4 md:px-6">
      <h2 class="text-2xl md:text-3xl font-serif font-medium text-gray-900 text-center mb-1">{{ getHeading(4) || 'Latest Wallpapers' }}</h2>
      <div class="w-10 h-[1.5px] bg-[#600b0b]/30 mx-auto mt-2 mb-6"></div>
      <div class="relative md:px-10">
        <button (click)="scrollNav(wallartScrollEl, 'left')" class="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg p-2.5 rounded-full hover:bg-[#600b0b] hover:text-white transition-all items-center justify-center border border-gray-100">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <button (click)="scrollNav(wallartScrollEl, 'right')" class="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg p-2.5 rounded-full hover:bg-[#600b0b] hover:text-white transition-all items-center justify-center border border-gray-100">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
        <div #wallartScroll class="flex gap-4 md:gap-6 overflow-x-auto pb-2" style="scrollbar-width: none; -ms-overflow-style: none;">
          <div *ngFor="let item of wallarts; trackBy: trackByIdx"
            class="flex-shrink-0 w-[42vw] sm:w-[220px] md:w-[260px] group cursor-pointer">
            <div class="aspect-square rounded-xl overflow-hidden shadow-sm group-hover:shadow-xl transition-all border border-gray-100 bg-gray-100">
              <img [src]="getWallArtImage(item)" [alt]="item.image_caption || item.title || ''"
                class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <p class="mt-2 text-xs md:text-sm font-medium text-gray-700 group-hover:text-[#600b0b] transition-colors truncate">{{ item.image_caption || item.title }}</p>
            <p *ngIf="item.category_name" class="text-[10px] text-gray-400 capitalize">{{ item.category_name }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ═══ 5. TRENDING WALLPAPERS ═══ -->
  <section *ngIf="wallpapers?.length > 0" class="bg-white py-8 md:py-10 border-t border-gray-100">
    <div class="max-w-[1440px] mx-auto px-4 md:px-6">
      <h2 class="text-2xl md:text-3xl font-serif font-medium text-gray-900 text-center mb-1">{{ getHeading(5) || 'Trending Wall Art' }}</h2>
      <div class="w-10 h-[1.5px] bg-[#600b0b]/30 mx-auto mt-2 mb-6"></div>
      <div class="relative md:px-10">
        <button (click)="scrollNav(wallpaperScrollEl, 'left')" class="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg p-2.5 rounded-full hover:bg-[#600b0b] hover:text-white transition-all items-center justify-center border border-gray-100">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <button (click)="scrollNav(wallpaperScrollEl, 'right')" class="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg p-2.5 rounded-full hover:bg-[#600b0b] hover:text-white transition-all items-center justify-center border border-gray-100">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
        <div #wallpaperScroll class="flex gap-4 md:gap-6 overflow-x-auto pb-2" style="scrollbar-width: none; -ms-overflow-style: none;">
          <div *ngFor="let wp of wallpapers; trackBy: trackByIdx"
            class="flex-shrink-0 w-[42vw] sm:w-[220px] md:w-[260px] group cursor-pointer">
            <div class="aspect-square rounded-xl overflow-hidden shadow-sm group-hover:shadow-xl transition-all border border-gray-100 bg-gray-100">
              <img [src]="wp.list_thumbnail || wp.thumbnail || wp.image" [alt]="wp.name || wp.caption || ''"
                class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <p class="mt-2 text-xs md:text-sm font-medium text-gray-700 group-hover:text-[#600b0b] transition-colors truncate">{{ wp.name || wp.caption }}</p>
            <p *ngIf="wp.wallpaper_type" class="text-[10px] text-gray-400 capitalize">{{ wp.wallpaper_type }} Design</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ═══ 6. FEATURED ARTS ═══ -->
  <section *ngIf="featuredArts?.length > 0" class="bg-white py-8 md:py-10 border-t border-gray-100">
    <div class="max-w-[1440px] mx-auto px-4 md:px-6">
      <h2 class="text-2xl md:text-3xl font-serif font-medium text-gray-900 text-center mb-1">{{ getHeading(6) || 'Featured Arts' }}</h2>
      <div class="w-10 h-[1.5px] bg-[#600b0b]/30 mx-auto mt-2 mb-6"></div>
      <div class="relative md:px-10">
        <button (click)="scrollNav(featuredArtScrollEl, 'left')" class="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg p-2.5 rounded-full hover:bg-[#600b0b] hover:text-white transition-all items-center justify-center border border-gray-100">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <button (click)="scrollNav(featuredArtScrollEl, 'right')" class="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg p-2.5 rounded-full hover:bg-[#600b0b] hover:text-white transition-all items-center justify-center border border-gray-100">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
        <div #featuredArtScroll class="flex gap-4 md:gap-6 overflow-x-auto pb-2" style="scrollbar-width: none; -ms-overflow-style: none;">
          <div *ngFor="let item of featuredArts; trackBy: trackByIdx"
            class="flex-shrink-0 w-[42vw] sm:w-[220px] md:w-[260px] group cursor-pointer">
            <div class="aspect-[4/3] rounded-xl overflow-hidden shadow-sm group-hover:shadow-xl transition-all border border-gray-100 bg-gray-100">
              <img [src]="item.image_2 || item.image || item.thumbnail || ''" [alt]="item.title || item.name || ''"
                class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <p class="mt-2 text-xs md:text-sm font-medium text-gray-700 group-hover:text-[#600b0b] transition-colors truncate">{{ item.title || item.name || item.caption }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ═══ 7. COLLAGE SETS ═══ -->
  <section *ngIf="collageSets?.length > 0" class="bg-white py-8 md:py-10 border-t border-gray-100">
    <div class="max-w-[1440px] mx-auto px-4 md:px-6">
      <h2 class="text-2xl md:text-3xl font-serif font-medium text-gray-900 text-center mb-1">{{ getHeading(7) || 'Frame Your Journey Collage Set' }}</h2>
      <div class="w-10 h-[1.5px] bg-[#600b0b]/30 mx-auto mt-2 mb-6"></div>
      <div class="relative md:px-10">
        <button (click)="scrollNav(collageScrollEl, 'left')" class="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg p-2.5 rounded-full hover:bg-[#600b0b] hover:text-white transition-all items-center justify-center border border-gray-100">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <button (click)="scrollNav(collageScrollEl, 'right')" class="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg p-2.5 rounded-full hover:bg-[#600b0b] hover:text-white transition-all items-center justify-center border border-gray-100">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
        <div #collageScroll class="flex gap-4 md:gap-6 overflow-x-auto pb-2" style="scrollbar-width: none; -ms-overflow-style: none;">
          <div *ngFor="let item of collageSets; trackBy: trackByIdx"
            class="flex-shrink-0 w-[42vw] sm:w-[220px] md:w-[260px] group cursor-pointer">
            <div class="aspect-[4/3] rounded-xl overflow-hidden shadow-sm group-hover:shadow-xl transition-all border border-gray-100 bg-gray-100">
              <img [src]="getCollageImage(item)" [alt]="item.name || item.caption || ''"
                class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <p class="mt-2 text-xs md:text-sm font-medium text-gray-700 group-hover:text-[#600b0b] transition-colors truncate">{{ item.name || item.caption }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ═══ 8. TOP SELLING / FEATURED FRAMES ═══ -->
  <section *ngIf="featuredFrames?.length > 0" class="bg-white py-8 md:py-10 border-t border-gray-100">
    <div class="max-w-[1440px] mx-auto px-4 md:px-6">
      <h2 class="text-2xl md:text-3xl font-serif font-medium text-gray-900 text-center mb-1">{{ getHeading(8) || 'Top Selling Frames' }}</h2>
      <div class="w-10 h-[1.5px] bg-[#600b0b]/30 mx-auto mt-2 mb-6"></div>
      <div class="relative md:px-10">
        <button (click)="scrollNav(featuredFrameScrollEl, 'left')" class="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg p-2.5 rounded-full hover:bg-[#600b0b] hover:text-white transition-all items-center justify-center border border-gray-100">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <button (click)="scrollNav(featuredFrameScrollEl, 'right')" class="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg p-2.5 rounded-full hover:bg-[#600b0b] hover:text-white transition-all items-center justify-center border border-gray-100">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
        <div #featuredFrameScroll class="flex gap-4 md:gap-6 overflow-x-auto pb-2" style="scrollbar-width: none; -ms-overflow-style: none;">
          <div *ngFor="let item of featuredFrames; trackBy: trackByIdx"
            class="flex-shrink-0 w-[42vw] sm:w-[220px] md:w-[260px] group cursor-pointer">
            <div class="aspect-[4/3] rounded-xl overflow-hidden shadow-sm group-hover:shadow-xl transition-all border border-gray-100 bg-gray-100">
              <img [src]="item.image_2 || item.image || item.thumbnail || ''" [alt]="item.title || item.name || ''"
                class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <p class="mt-2 text-xs md:text-sm font-medium text-gray-700 group-hover:text-[#600b0b] transition-colors truncate">{{ item.title || item.name || item.caption }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ═══ 9. TESTIMONIALS ═══ -->
  <section *ngIf="testimonials.length > 0" class="bg-[#fdf8f4] py-8 md:py-12 border-t border-gray-100">
    <div class="max-w-[1440px] mx-auto px-4 md:px-6">
      <h2 class="text-2xl md:text-3xl font-serif font-medium text-gray-900 text-center mb-1">What Customer Say About Us?</h2>
      <div class="w-10 h-[1.5px] bg-[#600b0b]/30 mx-auto mt-2 mb-2"></div>
      <!-- Star rating -->
      <div class="flex items-center justify-center gap-1 mb-6">
        <svg *ngFor="let s of [1,2,3,4,5]" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#f59e0b" stroke="#f59e0b" stroke-width="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
      </div>

      <div class="relative md:px-10">
        <button (click)="scrollNav(testimonialScrollEl, 'left')"
          class="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg p-2.5 rounded-full hover:bg-[#600b0b] hover:text-white transition-all items-center justify-center border border-gray-100">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <button (click)="scrollNav(testimonialScrollEl, 'right')"
          class="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-lg p-2.5 rounded-full hover:bg-[#600b0b] hover:text-white transition-all items-center justify-center border border-gray-100">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
        </button>

        <div #testimonialScroll class="flex gap-4 md:gap-5 overflow-x-auto scroll-smooth pb-2 select-none"
          style="scrollbar-width: none; -ms-overflow-style: none;">
          <div *ngFor="let t of testimonials; trackBy: trackByIdx"
            class="flex-shrink-0 w-[75vw] sm:w-[280px] md:w-[300px] bg-white rounded-xl p-5 shadow-sm border border-gray-100">
            <!-- Stars -->
            <div class="flex gap-0.5 mb-3">
              <svg *ngFor="let s of [1,2,3,4,5]" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                [attr.fill]="s <= (t.rating || 5) ? '#f59e0b' : '#e5e7eb'" stroke="none">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
              </svg>
            </div>
            <!-- Review image -->
            <div *ngIf="getTestimonialImage(t)" class="mb-3 aspect-[4/3] rounded-lg overflow-hidden bg-gray-100">
              <img [src]="getTestimonialImage(t)" [alt]="t.user?.name || t.title?.name || ''" class="w-full h-full object-cover pointer-events-none" />
            </div>
            <!-- Review text -->
            <p class="text-xs text-gray-600 leading-relaxed mb-3 line-clamp-4">{{ t.review }}</p>
            <!-- Author -->
            <p class="text-xs font-bold text-gray-900">{{ t.user?.name || t.title?.name || 'Customer' }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ═══ 10. WHY MAHATTAART ═══ -->
  <section class="bg-white py-8 md:py-12 border-t border-gray-100">
    <div class="max-w-[1440px] mx-auto px-4 md:px-6">
      <h2 class="text-2xl md:text-3xl font-serif font-medium text-gray-900 text-center mb-1">Why MahattaArt?</h2>
      <div class="w-10 h-[1.5px] bg-[#600b0b]/30 mx-auto mt-2 mb-8"></div>
      <div class="grid grid-cols-3 md:grid-cols-5 gap-y-8 gap-x-4 max-w-4xl mx-auto">
        <div *ngFor="let item of whyItems; trackBy: trackByIdx" class="flex flex-col items-center text-center">
          <div class="w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#fdf5f5] flex items-center justify-center mb-2">
            <img [src]="item.icon" [alt]="item.label" class="w-8 h-8 md:w-9 md:h-9 object-contain"
              onerror="this.style.display='none'" />
          </div>
          <p class="text-[10px] md:text-xs font-semibold text-gray-700 leading-tight">{{ item.label }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- ═══ 11. ART FOR BUSINESS + ART ADVISORY ═══ -->
  <section class="bg-white py-8 md:py-12 border-t border-gray-100">
    <div class="max-w-[1440px] mx-auto px-4 md:px-6">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
        <!-- Art For Business -->
        <div class="group">
          <h3 class="text-lg md:text-xl font-serif text-gray-900 mb-4">{{ getHeading(2) || 'Art For Business' }}</h3>
          <a *ngIf="artForBusiness" [href]="artForBusiness.button_link || '/art-for-business'"
            class="block rounded-xl overflow-hidden border border-gray-200 shadow-sm group-hover:shadow-lg transition-all">
            <img [src]="artForBusiness.image" [alt]="artForBusiness.alt_text || 'Art For Business'"
              class="w-full h-auto hidden md:block group-hover:scale-[1.01] transition-transform duration-500" />
            <img [src]="artForBusiness.mobile_image || artForBusiness.image" [alt]="artForBusiness.alt_text || 'Art For Business'"
              class="w-full h-auto md:hidden" />
          </a>
          <a *ngIf="!artForBusiness" routerLink="/art-for-business"
            class="block rounded-xl overflow-hidden border border-gray-200 bg-[#fdf5f5] p-8 text-center hover:shadow-lg transition-all">
            <p class="text-[#600b0b] text-sm font-semibold">Explore Art For Business</p>
          </a>
        </div>
        <!-- Art Advisory -->
        <div class="group">
          <h3 class="text-lg md:text-xl font-serif text-gray-900 mb-4">{{ getHeading(3) || 'Art By Advisory' }}</h3>
          <!-- <div *ngIf="artAdvisory" class="rounded-xl overflow-hidden border border-gray-200 shadow-sm group-hover:shadow-lg transition-all">
            <a [href]="artAdvisory.button_link || '#'" class="block">
              <img [src]="artAdvisory.image" [alt]="artAdvisory.alt_text || 'Art Advisory'"
                class="w-full h-auto hidden md:block group-hover:scale-[1.01] transition-transform duration-500" />
              <img [src]="artAdvisory.mobile_image || artAdvisory.image" [alt]="artAdvisory.alt_text || 'Art Advisory'"
                class="w-full h-auto md:hidden" />
            </a>
          </div> -->
        </div>
      </div>
    </div>
  </section>

</div>
